import { Deserializable } from './deserializable.model';

export class Icon implements Deserializable<any, Icon> {
  constructor(public image?: string, public altText?: string) {}

  deserialize(input: any): Icon {
    if (input == null) {
      return null;
    }

    this.image = input['image'];
    this.altText = input['altText'];

    return this;
  }
}
